/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Activating_ButtonInputs */



/**
* | output |
* | --- |
* | "Activating..." |
*
* @param {Login_Offline_Activating_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activating_button = /** @type {((inputs?: Login_Offline_Activating_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activating_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activation en cours...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivierung...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attivazione in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Активация...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activando...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("激活...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("有効化中...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सक्रिय हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativando...")
	return /** @type {LocalizedString} */ ("Activating...")
});